// Dane przykładowe (fixture) dla modułu kompatybilności falownik↔magazyn,
// zgodne z kształtem odpowiedzi z 00_KONTRAKT.md §4. To WYŁĄCZNIE dane —
// żadnego wnioskowania o kompatybilności na podstawie napięcia/producenta/nazwy.
// Odpowiedzi `/check` dla każdej pary są z góry zdefiniowane w CHECK_TABLE
// (odpowiednik tabeli `compatibility_rule` z backendu), nie liczone w locie.

export const MOCK_INVERTERS = [
  { id: 1, manufacturer: 'Deye', product_name: 'Falownik hybrydowy Deye SUN-10K-SG04LP3-EU', series_label: 'SUN-SG04LP3-EU', power_kw: 10, phase: '3', voltage_class: 'LV', battery_capable: true, product_url: '/inwerter/1' },
  { id: 2, manufacturer: 'Deye', product_name: 'Falownik hybrydowy Deye SUN-12K-SG01HP3-EU', series_label: 'SUN-SG01HP3-EU', power_kw: 12, phase: '3', voltage_class: 'HV', battery_capable: true, product_url: '/inwerter/2' },
  { id: 3, manufacturer: 'Growatt', product_name: 'Falownik hybrydowy Growatt MOD 7000TL3-XH', series_label: 'MOD-XH', power_kw: 7, phase: '3', voltage_class: null, battery_capable: true, product_url: '/inwerter/3' },
  { id: 4, manufacturer: 'GoodWe', product_name: 'Falownik hybrydowy GoodWe ET15-30K', series_label: 'ET', power_kw: 15, phase: '3', voltage_class: 'HV', battery_capable: true, product_url: '/inwerter/4' },
  { id: 5, manufacturer: 'Sofar', product_name: 'Falownik hybrydowy Sofar HYD-30K-T1', series_label: 'HYD-T1', power_kw: 30, phase: '3', voltage_class: 'HV', battery_capable: true, product_url: '/inwerter/5' },
  { id: 6, manufacturer: 'Deye', product_name: 'Falownik Deye SUN-5K-G06P3-EU-BM2', series_label: 'SUN-G06P3-EU', power_kw: 5, phase: '3', voltage_class: 'LV', battery_capable: false, product_url: '/inwerter/6' },
  { id: 7, manufacturer: 'Huawei', product_name: 'Falownik hybrydowy Huawei SUN2000-10KTL-M1', series_label: 'SUN2000-M1', power_kw: 10, phase: '3', voltage_class: 'HV', battery_capable: true, product_url: '/inwerter/7' },
];

export const MOCK_BATTERIES = [
  { id: 101, manufacturer: 'Pylontech', product_name: 'Magazyn energii Pylontech US5000', family_label: 'US5000', capacity_kwh: 4.8, voltage_class: 'LV', product_url: '/magazyn/101' },
  { id: 102, manufacturer: 'Pylontech', product_name: 'Magazyn energii Pylontech Force H2', family_label: 'Force H2', capacity_kwh: 3.55, voltage_class: 'HV', product_url: '/magazyn/102' },
  { id: 103, manufacturer: 'BYD', product_name: 'Magazyn energii BYD Battery-Box Premium HVS', family_label: 'HVS', capacity_kwh: 5.12, voltage_class: 'HV', product_url: '/magazyn/103' },
  { id: 104, manufacturer: 'Dyness', product_name: 'Magazyn energii Dyness STACK100', family_label: 'STACK100', capacity_kwh: 5.0, voltage_class: 'LV', product_url: '/magazyn/104' },
  { id: 105, manufacturer: 'Huawei', product_name: 'Magazyn energii Huawei LUNA2000-10-E1', family_label: 'LUNA2000', capacity_kwh: 10, voltage_class: 'HV', product_url: '/magazyn/105' },
  { id: 106, manufacturer: 'NoName', product_name: 'Magazyn energii NoName PowerCell X1', family_label: null, capacity_kwh: 5, voltage_class: null, product_url: '/magazyn/106' },
  { id: 107, manufacturer: 'Pylontech', product_name: 'Magazyn energii Pylontech Force H3', family_label: 'Force H3', capacity_kwh: 3.55, voltage_class: 'HV', product_url: '/magazyn/107' },
];

const bySourceDate = (id, publisher, title, date, url) => ({
  source_id: id, publisher, title, publication_date: date, url, is_official: true, access_date: '2026-07-18',
});

// Klucz: `${inverterId}:${batteryId}` -> pełna odpowiedź /check.
const CHECK_TABLE = {
  // compatible — oba urządzenia LV, potwierdzenie obu producentów.
  '1:101': {
    user_status: 'compatible', status_label_pl: 'Kompatybilne', internal_status: 'compatible',
    confidence: 'official_both_sides', reason_code: null,
    conditions: [
      { type: 'firmware', label_pl: 'Wymagany firmware', value_pl: 'Falownik ARM ≥ 19' },
      { type: 'setting', label_pl: 'Ustawienie falownika', value_pl: 'Kod baterii: 00 (Pylontech)' },
    ],
    capacity: { module_capacity_kwh: 4.8, min_modules: 1, max_modules_per_tower: 8, max_capacity_per_tower_kwh: 38.4, max_parallel_towers: null, max_total_capacity_kwh: 38.4, note_pl: 'Limit dotyczy jednej wieży.' },
    required_bms: null, communication_protocol: 'CAN', limitations_pl: null,
    sources: [bySourceDate('S001', 'Deye', 'Battery Compatibility List LV v3.2', '2026-03-10', 'https://example.com/deye-lv-compat.pdf')],
    last_verified: '2026-07-10', requires_manual_review: false,
  },
  // incompatible — niezgodność klas napięciowych (LV bateria, HV falownik).
  '2:101': {
    user_status: 'incompatible', status_label_pl: 'Niekompatybilne', internal_status: 'incompatible',
    confidence: 'official_both_sides', reason_code: 'voltage_class_mismatch',
    conditions: [], capacity: null, required_bms: null, communication_protocol: null,
    limitations_pl: 'Falownik pracuje w klasie wysokiego napięcia (HV), a ten magazyn tylko w klasie niskiego napięcia (LV).',
    sources: [], last_verified: '2026-07-10', requires_manual_review: false,
  },
  // incompatible — system zamknięty (LUNA2000 tylko z Huawei).
  '1:105': {
    user_status: 'incompatible', status_label_pl: 'Niekompatybilne', internal_status: 'incompatible',
    confidence: 'official_battery_manufacturer', reason_code: 'closed_ecosystem',
    conditions: [], capacity: null, required_bms: null, communication_protocol: null,
    limitations_pl: 'Magazyny Huawei LUNA2000 współpracują wyłącznie z falownikami Huawei.',
    sources: [bySourceDate('S010', 'Huawei', 'LUNA2000 Compatible Inverters List', '2026-01-20', 'https://example.com/huawei-luna-compat.pdf')],
    last_verified: '2026-06-01', requires_manual_review: false,
  },
  // compatible — Huawei + Huawei (ten sam ekosystem).
  '7:105': {
    user_status: 'compatible', status_label_pl: 'Kompatybilne', internal_status: 'compatible',
    confidence: 'official_both_sides', reason_code: null,
    conditions: [{ type: 'firmware', label_pl: 'Wymagany firmware', value_pl: 'SUN2000 ≥ V100R023' }],
    capacity: { module_capacity_kwh: 5, min_modules: 1, max_modules_per_tower: 3, max_capacity_per_tower_kwh: 15, max_parallel_towers: null, max_total_capacity_kwh: 15, note_pl: 'Limit dotyczy jednej wieży.' },
    required_bms: null, communication_protocol: 'CAN', limitations_pl: null,
    sources: [bySourceDate('S010', 'Huawei', 'LUNA2000 Compatible Inverters List', '2026-01-20', 'https://example.com/huawei-luna-compat.pdf')],
    last_verified: '2026-06-01', requires_manual_review: false,
  },
  // conflicting — sprzeczne źródła (sprzedawca vs. dokumentacja producenta).
  '2:102': {
    user_status: 'conflicting', status_label_pl: 'Sprzeczne informacje', internal_status: 'conflicting_information',
    confidence: 'retailer_only', reason_code: null,
    conditions: [{ type: 'firmware', label_pl: 'Wymagany firmware', value_pl: 'Falownik 2001-X018, kontroler baterii ≥ V1.7 (wg dokumentacji Pylontech)' }],
    capacity: { module_capacity_kwh: 3.55, min_modules: 2, max_modules_per_tower: 5, max_capacity_per_tower_kwh: 17.75, max_parallel_towers: null, max_total_capacity_kwh: 17.75, note_pl: 'Limit dotyczy jednej wieży.' },
    required_bms: 'HVC 60050-A1', communication_protocol: 'CAN',
    limitations_pl: 'Dystrybutor deklaruje pełną kompatybilność, ale oficjalna dokumentacja Pylontech nie wymienia tego modelu falownika wprost.',
    sources: [
      bySourceDate('S020', 'Sprzedawca X', 'Oferta produktowa (deklaracja handlowa)', '2026-05-02', 'https://example.com/sprzedawca-x-oferta'),
      bySourceDate('S007', 'Pylontech', 'Compatibility List HV ESS Ver.2.40', '2025-08-15', 'https://example.com/pylontech-hv-compat.pdf'),
    ],
    last_verified: '2026-07-15', requires_manual_review: true,
  },
  // conditional — pełny przykład z kontraktu (§4), liczba modułów jako warunek + ostrzeżenie.
  '4:104': {
    user_status: 'conditional', status_label_pl: 'Kompatybilne warunkowo', internal_status: 'compatible_conditionally',
    confidence: 'official_inverter_manufacturer', reason_code: null,
    conditions: [
      { type: 'firmware', label_pl: 'Wymagany firmware', value_pl: 'Falownik ≥ ARM 22, kontroler baterii ≥ V1.2' },
      { type: 'modules', label_pl: 'Liczba modułów', value_pl: 'od 3 do 6 (parzysta liczba na wieżę)' },
      { type: 'cable', label_pl: 'Przewód komunikacyjny', value_pl: 'Dedykowany kabel CAN GoodWe-Dyness (w zestawie)' },
    ],
    capacity: { module_capacity_kwh: 5.0, min_modules: 3, max_modules_per_tower: 6, max_capacity_per_tower_kwh: 30, max_parallel_towers: null, max_total_capacity_kwh: 30, note_pl: 'Limit dotyczy jednej wieży.' },
    required_bms: null, communication_protocol: 'CAN',
    limitations_pl: 'UWAGA: niezgodna (nieparzysta) liczba modułów w wieży może uszkodzić falownik.',
    sources: [bySourceDate('S015', 'GoodWe', 'Battery Compatibility List ET Series', '2026-02-01', 'https://example.com/goodwe-et-compat.pdf')],
    last_verified: '2026-07-01', requires_manual_review: false,
  },
  // incompatible — falownik bez portu bateryjnego DC.
  '6:101': {
    user_status: 'incompatible', status_label_pl: 'Niekompatybilne', internal_status: 'incompatible',
    confidence: 'official_inverter_manufacturer', reason_code: 'inverter_has_no_dc_battery_port',
    conditions: [], capacity: null, required_bms: null, communication_protocol: null,
    limitations_pl: 'Ten falownik nie ma wejścia bateryjnego DC.',
    sources: [], last_verified: '2026-06-20', requires_manual_review: false,
  },
  // unknown — dokumentacja nieczytelna (krok 2b, ANEKS A2: Sofar HYD-T1 = skan bez warstwy tekstowej).
  '5:101': {
    user_status: 'unknown', status_label_pl: 'Brak potwierdzonych danych', internal_status: 'unknown',
    confidence: null, reason_code: 'documentation_unreadable',
    conditions: [], capacity: null, required_bms: null, communication_protocol: null, limitations_pl: null,
    sources: [], last_verified: null, requires_manual_review: false,
  },
  // unknown — seria niejednoznaczna (LV/HV nierozróżnialne po nazwie), brak reguły w bazie.
  '3:101': {
    user_status: 'unknown', status_label_pl: 'Brak potwierdzonych danych', internal_status: 'not_listed',
    confidence: null, reason_code: 'no_rule_in_database',
    conditions: [], capacity: null, required_bms: null, communication_protocol: null, limitations_pl: null,
    sources: [], last_verified: null, requires_manual_review: false,
  },
  // compatible — BYD HVS + Deye HV (ANEKS A7: regresja naprawiona, aktualna lista
  // Deye HV DY-HV(160-800)-036 dopuszcza baterie firm trzecich, w tym BYD HVS/HVM).
  '2:103': {
    user_status: 'compatible', status_label_pl: 'Kompatybilne', internal_status: 'compatible',
    confidence: 'official_inverter_manufacturer', reason_code: null,
    conditions: [
      { type: 'firmware', label_pl: 'Wymagany firmware', value_pl: 'Falownik ≥ ARM 25' },
      { type: 'modules', label_pl: 'Liczba modułów', value_pl: '4–8 modułów BYD HVS' },
    ],
    capacity: { module_capacity_kwh: 2.56, min_modules: 4, max_modules_per_tower: 8, max_capacity_per_tower_kwh: 20.48, max_parallel_towers: null, max_total_capacity_kwh: 20.48, note_pl: 'Limit dotyczy jednej wieży.' },
    required_bms: null, communication_protocol: 'CAN',
    limitations_pl: null,
    sources: [bySourceDate('S030', 'Deye', 'DY-HV(160-800)-036 Battery Compatibility List', '2026-04-21', 'https://example.com/deye-hv-036-compat.pdf')],
    last_verified: '2026-07-16', requires_manual_review: false,
  },
  // unknown — reguła o statusie not_listed (ANEKS A7: Force H3 nie występuje na aktualnej
  // liście HV Deye, na której są Force H1 i H2 — brak wpisu w źródle, nie "nie zadziała").
  '2:107': {
    user_status: 'unknown', status_label_pl: 'Brak potwierdzonych danych', internal_status: 'not_listed',
    confidence: null, reason_code: 'not_listed_in_source',
    conditions: [], capacity: null, required_bms: null, communication_protocol: null, limitations_pl: null,
    sources: [bySourceDate('S030', 'Deye', 'DY-HV(160-800)-036 Battery Compatibility List', '2026-04-21', 'https://example.com/deye-hv-036-compat.pdf')],
    last_verified: '2026-07-16', requires_manual_review: false,
  },
  // unknown — reguła o statusie insufficient_data (tylko deklaracja handlowa dystrybutora).
  '4:102': {
    user_status: 'unknown', status_label_pl: 'Brak potwierdzonych danych', internal_status: 'unknown',
    confidence: 'retailer_only', reason_code: 'insufficient_evidence',
    conditions: [], capacity: null, required_bms: null, communication_protocol: null, limitations_pl: null,
    sources: [bySourceDate('S040', 'Dystrybutor Y', 'Karta produktu (deklaracja handlowa)', '2026-06-01', 'https://example.com/dystrybutor-y-karta')],
    last_verified: null, requires_manual_review: false,
  },
  // unknown — celowo NIEZNANY frontendowi reason_code (test zachowania defensywnego z ANEKS A1/A6).
  '7:104': {
    user_status: 'unknown', status_label_pl: 'Brak potwierdzonych danych', internal_status: 'unknown',
    confidence: null, reason_code: 'some_future_code',
    conditions: [], capacity: null, required_bms: null, communication_protocol: null, limitations_pl: null,
    sources: [], last_verified: null, requires_manual_review: false,
  },
};

// Produkt spoza mapowania — zawsze unmapped_product, niezależnie od pary.
const UNMAPPED_BATTERY_ID = 106;

const genericUnknown = (reasonCode) => ({
  user_status: 'unknown', status_label_pl: 'Brak potwierdzonych danych', internal_status: reasonCode === 'unmapped_product' ? 'unknown' : 'not_listed',
  confidence: null, reason_code: reasonCode,
  conditions: [], capacity: null, required_bms: null, communication_protocol: null, limitations_pl: null,
  sources: [], last_verified: null, requires_manual_review: false,
});

export const resolveCheck = (inverterId, batteryId) => {
  const inv = MOCK_INVERTERS.find((i) => i.id === Number(inverterId));
  const bat = MOCK_BATTERIES.find((b) => b.id === Number(batteryId));
  if (!inv || !bat) return null;

  const key = `${inv.id}:${bat.id}`;
  const fixed = CHECK_TABLE[key];
  const base = fixed || (Number(bat.id) === UNMAPPED_BATTERY_ID ? genericUnknown('unmapped_product') : genericUnknown('no_rule_in_database'));

  return {
    ...base,
    inverter: { id: inv.id, manufacturer: inv.manufacturer, product_name: inv.product_name, series_label: inv.series_label, voltage_class: inv.voltage_class, battery_inputs: inv.battery_capable ? 1 : 0, product_url: inv.product_url },
    battery: { id: bat.id, manufacturer: bat.manufacturer, product_name: bat.product_name, family_label: bat.family_label, voltage_class: bat.voltage_class, product_url: bat.product_url },
    offers: { inverter_offers_url: `/oferty/${inv.id}`, battery_offers_url: `/oferty/${bat.id}` },
  };
};
